export default __webpack_public_path__ + "media/images/admin/chart-66057271f0d0121afe087af2b76362d3.svg";